    import {FETCH_BANK_ACCOUNTS_REQUEST, FETCH_BANK_ACCOUNTS_SUCCESS, FETCH_BANK_ACCOUNTS_FAILURE} from "../../constants/FetchBankAccounts";

const initialState = {
    bankAccounts: [],
    drAgency: null,
    loading: false,
    error: null
  };

const bankAccountsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_BANK_ACCOUNTS_REQUEST:
            return { ...state, loading: true };
        case FETCH_BANK_ACCOUNTS_SUCCESS:
            return { ...state, bankAccounts: action.payload, loading: false };
        case FETCH_BANK_ACCOUNTS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default bankAccountsReducer;